export const TRANSFERS_CSAT_SURVEY_ID = 1163;
export const REDESIGN_CSAT_SURVEY_ID = 1317;